import React, { useEffect, useState } from "react";
import * as S from "./ArticleLegalAdvice.sc";
import ButtonHref from "../Button/ButtonHref";
import Link from "next/link";

const ArticleLegalAdvice = () => {
  return (
    <S.Container>
      <S.Header>Masz pytania?</S.Header>
      <Link href={"/[text-site]"} as={"/porady-prawne"} passHref={true}>
        <S.HtmlLink>
          <ButtonHref
            color={"green"}
            customStyle={{ marginTop: 0, alignSelf: "center" }}
          >
            Zadaj pytanie redakcji
          </ButtonHref>
        </S.HtmlLink>
      </Link>
    </S.Container>
  );
};

export default ArticleLegalAdvice;
